<template>
  <div style="background-color: #edf4fc;">
    <div class="content-title">
      <span style="font-size: 0.3rem; line-height: 0.6rem">院校库</span>
      <br />
      <span style="font-size: 0.15rem">为用户提供权威的MBA招生单位信息查询服务</span>
    </div>
    <div style="overflow: hidden;border: 1px dashed rgb(223, 221, 221);margin: 0.1rem;">
      <div style="border-bottom: 1px dashed rgb(223, 221, 221);">
        <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据学校名称搜索学校信息：</div>
        <div class="content-input">
          <el-input v-model="schoolName" placeholder="请输入学校名称" class="content-input-el" clearable @keyup.enter.native="schoolFind()"></el-input>
          <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="schoolFind()">搜索</el-button>
        </div>
      </div>
      <div>
        <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据查询条件搜索学校信息：</div>
        <div class="content-table">
          <div class="content-table-1">
            <div class="content-table-11">院校所在地：</div>
            <div class="content-table-12">
              <el-radio-group v-model="idProvince" @change="changeSelectProvince">
                <el-radio label="全部" style="margin-right: 0.13rem; margin-bottom: 0.1rem">全部</el-radio>
                <el-radio label="北京" style="margin-right: 0.13rem; margin-bottom: 0.1rem">北京</el-radio>
                <el-radio label="天津" style="margin-right: 0.13rem; margin-bottom: 0.1rem">天津</el-radio>
                <el-radio label="河北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河北</el-radio>
                <el-radio label="山西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山西</el-radio>
                <el-radio label="内蒙古" style="margin-right: 0.13rem; margin-bottom: 0.1rem">内蒙古</el-radio>
                <el-radio label="辽宁" style="margin-right: 0.13rem; margin-bottom: 0.1rem">辽宁</el-radio>
                <el-radio label="吉林" style="margin-right: 0.13rem; margin-bottom: 0.1rem">吉林</el-radio>
                <el-radio label="黑龙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">黑龙江</el-radio>
                <el-radio label="上海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">上海</el-radio>
                <el-radio label="江苏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江苏</el-radio>
                <el-radio label="浙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">浙江</el-radio>
                <el-radio label="安徽" style="margin-right: 0.13rem; margin-bottom: 0.1rem">安徽</el-radio>
                <el-radio label="福建" style="margin-right: 0.13rem; margin-bottom: 0.1rem">福建</el-radio>
                <el-radio label="江西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江西</el-radio>
                <el-radio label="山东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山东</el-radio>
                <el-radio label="河南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河南</el-radio>
                <el-radio label="湖北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖北</el-radio>
                <el-radio label="湖南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖南</el-radio>
                <el-radio label="广东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广东</el-radio>
                <el-radio label="广西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广西</el-radio>
                <el-radio label="海南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">海南</el-radio>
                <el-radio label="重庆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">重庆</el-radio>
                <el-radio label="四川" style="margin-right: 0.13rem; margin-bottom: 0.1rem">四川</el-radio>
                <el-radio label="贵州" style="margin-right: 0.13rem; margin-bottom: 0.1rem">贵州</el-radio>
                <el-radio label="云南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">云南</el-radio>
                <el-radio label="西藏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">西藏</el-radio>
                <el-radio label="陕西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">陕西</el-radio>
                <el-radio label="甘肃" style="margin-right: 0.13rem; margin-bottom: 0.1rem">甘肃</el-radio>
                <el-radio label="青海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">青海</el-radio>
                <el-radio label="宁夏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">宁夏</el-radio>
                <el-radio label="新疆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">新疆</el-radio>
                <el-radio label="香港" style="margin-right: 0.13rem; margin-bottom: 0.1rem">香港</el-radio>
                <el-radio label="澳门" style="margin-right: 0.13rem; margin-bottom: 0.1rem">澳门</el-radio>
                <el-radio label="台湾" style="margin-right: 0.13rem; margin-bottom: 0.1rem">台湾</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="content-table-2">
            <div class="content-table-21">报考专业：</div>
            <div class="content-table-22">
              <el-radio-group v-model="idMajor" @change="changeSelectMajor">
                <el-radio label="全部" style="margin-right: 0.13rem">全部</el-radio>
                <el-radio label="MBA" style="margin-right: 0.13rem">MBA</el-radio>
                <el-radio label="MEM-125601" style="margin-right: 0.13rem">MEM-125601</el-radio>
                <el-radio label="MEM-125602" style="margin-right: 0.13rem">MEM-125602</el-radio>
                <el-radio label="MPA" style="margin-right: 0.13rem">MPA</el-radio>
                <el-radio label="MTA" style="margin-right: 0.13rem">MTA</el-radio>
                <el-radio label="EMBA" style="margin-right: 0.13rem">EMBA</el-radio>
                <el-radio label="MPAcc" style="margin-right: 0.13rem">MPAcc</el-radio>
                <el-radio label="MAud" style="margin-right: 0.13rem">MAud</el-radio>
                <el-radio label="MEM-125603" style="margin-right: 0.13rem">MEM-125603</el-radio>
                <el-radio label="MEM-125604" style="margin-right: 0.13rem">MEM-125604</el-radio>
                <el-radio label="Mlis" style="margin-right: 0.13rem">Mlis</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="height: 0.06rem;"></div>
          <div class="content-table-2">
            <div class="content-table-21">报考年级：</div>
            <div class="content-table-22">
              <el-radio-group v-model="idGrade" @change="changeSelectGrade">
                <el-radio :label="20" style="margin-right: 0.13rem">全部</el-radio>
                <el-radio :label="2021" style="margin-right: 0.13rem">2021</el-radio>
                <el-radio :label="2022" style="margin-right: 0.13rem">2022</el-radio>
                <el-radio :label="2023" style="margin-right: 0.13rem">2023</el-radio>
                <el-radio :label="2024" style="margin-right: 0.13rem">2024</el-radio>
                <el-radio :label="2025" style="margin-right: 0.13rem">2025</el-radio>
                <el-radio :label="2026" style="margin-right: 0.13rem">2026</el-radio>
                <el-radio :label="2027" style="margin-right: 0.13rem">2027</el-radio>
                <el-radio :label="2028" style="margin-right: 0.13rem">2028</el-radio>
                <el-radio :label="2029" style="margin-right: 0.13rem">2029</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <p style="font-size: 0.13rem">注：各招生单位的院校库信息由其自主维护，如有疑问，请咨询发布单位。</p>
      <p style="font-size: 0.13rem">解释：院校库信息中，<span style="color: blue;">蓝色</span>代表存在该链接内容，<span style="color: green;">绿色</span>代表暂时不存在该链接内容，点击时请注意。</p>
      <div class="content-body-box" v-for="item in bodyBox" :key="item.id + item.grade">
        <div class="box-info">
          <div class="box-img">
            <el-image style="width: 0.8rem; height: 0.8rem;" :src="item.logo">
              <div style="width: 0.8rem; height: 0.8rem" slot="error" v-loading="loading"></div>
            </el-image>
          </div>
          <div class="box-info-1" style="padding-top: 0.05rem;">
            <a :href="item.web" target="_blank">{{ item.name }}</a>
            &nbsp;&nbsp;&nbsp;
            <i class="el-icon-location-outline box-info-address"></i>
            <span class="box-info-address">{{ item.address }}</span>
          </div>
          <div class="box-info-1">
            <span style="color: #000">专业：</span>
            <span style="color: red">{{ item.major }}</span>
            &nbsp;&nbsp;&nbsp;
            <span style="color: #000">年级：</span>
            <span style="color: red">{{ item.grade }}</span>
          </div>
          <div class="box-info-2">
            <a href="javascript:void(0);" @click="enrollmentKong(item)" :class="item.enrollment === '' ? 'kong' : 'bukong' ">招生简章</a>
            <span class="col-line"></span>
            <a href="javascript:void(0);" @click="noticeKong(item)" :class="item.notice === '' ? 'kong' : 'bukong' ">面试通知</a>
            <span class="col-line"></span>
            <a href="javascript:void(0);" @click="listKong(item)" :class="item.list === '' ? 'kong' : 'bukong' ">录取名单</a>
            <span class="col-line"></span>
            <a href="javascript:void(0);" @click="methodKong(item)" :class="item.method === '' ? 'kong' : 'bukong' ">调剂方式</a>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #edf4fc; padding-bottom: 0.2rem">
      <el-pagination :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { getSchoolName, SelectSchool } from '@/api/collegelibraryAPI'

export default {
  name: 'CollegeLibrary',
  data() {
    return {
      schoolName: '',
      currentPage: 1,
      pageSize: 12,
      total: 1,
      bodyBox: [],
      idProvince: '全部',
      idMajor: '全部',
      idGrade: 20,
      idButton: 0,
      loading: true
    }
  },
  created() {
    this.contentFind()
  },
  computed: {
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async contentFind() {
      const { data: res } = await SelectSchool(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.bodyBox = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async schoolFind() {
      const { data: res } = await getSchoolName(this.schoolName, this.currentPage, this.pageSize)
      this.bodyBox = res.data[2]
      this.total = res.data[0]
      this.idButton = 2
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      document.documentElement.scrollTop = 450
      if (this.idButton === 2) {
        const { data: res } = await getSchoolName(this.schoolName, this.currentPage, this.pageSize)
        this.bodyBox = res.data[2]
        this.total = res.data[0]
      }
      if (this.idButton === 3) {
        const { data: res } = await SelectSchool(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
        this.bodyBox = res.data[2]
        this.total = res.data[0]
      }
    },
    async changeSelectMajor() {
      this.currentPage = 1
      const { data: res } = await SelectSchool(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.bodyBox = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async changeSelectProvince() {
      this.currentPage = 1
      const { data: res } = await SelectSchool(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.bodyBox = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async changeSelectGrade() {
      this.currentPage = 1
      const { data: res } = await SelectSchool(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.bodyBox = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    enrollmentKong(item) {
      if (item.enrollment === '') {
        this.$message({
          message: item.name + item.grade + '级招生简章暂时不存在',
          type: 'info'
        })
      } else {
        window.open(item.enrollment, '_blank')
      }
    },
    noticeKong(item) {
      if (item.notice === '') {
        this.$message({
          message: item.name + item.grade + '级面试通知暂时不存在',
          type: 'info'
        })
      } else {
        window.open(item.notice, '_blank')
      }
    },
    listKong(item) {
      if (item.list === '') {
        this.$message({
          message: item.name + item.grade + '级录取名单暂时不存在',
          type: 'info'
        })
      } else {
        window.open(item.list, '_blank')
      }
    },
    methodKong(item) {
      if (item.method === '') {
        this.$message({
          message: item.name + item.grade + '级调剂方法暂时不存在',
          type: 'info'
        })
      } else {
        window.open(item.method, '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
  font-size: 0.13rem;
}
.content-title {
  text-align: center;
  color: yellow;
  height: 1rem;
  background-color: #061238;
}
.content-input {
  margin: 0.1rem;
  .content-input-el {
    width: 3rem;
  }
}
.content-table {
  margin: 0.1rem;
}
.content-table-1 {
  overflow: hidden;
  padding-top: 0.02rem;
}
.content-table-11 {
  float: left;
  width: 9%;
  font-size: 0.13rem;
}
.content-table-12 {
  float: left;
  width: 91%;
}
.content-table-2 {
  overflow: hidden;
}
.content-table-21 {
  float: left;
  width: 9%;
  font-size: 0.13rem;
  padding-top: 0.01rem;
}
.content-table-22 {
  float: left;
  padding-top: 0.05rem;
  width: 91%;
}
.col-line {
  display: inline-flex;
  width: 1px;
  height: 0.08rem;
  margin: 0 0.1rem;
  background: #dcdcdc;
}
.content-body {
  overflow: hidden;
  background-color: #edf4fc;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
}
.content-body-box:nth-child(odd) {
  float: left;
  height: 1.05rem;
  width: 49%;
  margin-bottom: 0.2rem;
  margin-right: 0!important;
  background-color: white;
  border-radius: 0.1rem;
  border: 1px solid rgb(216, 215, 215);
}
.content-body-box:nth-child(even) {
  float: right;
  height: 1.05rem;
  width: 49%;
  margin-bottom: 0.2rem;
  background-color: white;
  border-radius: 0.1rem;
  border: 1px solid rgb(216, 215, 215);
}
.box-info {
  float: left;
  width: 4.3rem;
  height: 0.8rem;
  margin-left: 0.1rem;
  margin-top: 0.05rem;
}
.box-img {
  float: left;
  width: 0.8rem;
  height: 0.8rem;
  margin-top: 0.1rem;
  margin-right: 0.1rem;
}
.box-info-1 {
  margin-top: 010px;
  font-size: 0.13rem;
}
.box-info-address {
  font-size: 0.12rem;
}
.box-info-2 {
  margin-top: 10px;
  a {
    font-size: 0.13rem;
  }
}
.box-info-2 a:hover {
  color: red;
}
.kong {
  color: green;
}
.bukong {
  color: blue;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio {
  margin-right: 0.09rem;
  margin-bottom: 0.05rem;
}
/deep/ .el-radio__label {
  padding-left: 0;
  font-size: 0.13rem;
}
/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #0000FF;
}
/deep/ .el-tabs__nav-scroll {
  border-bottom: none;
}
/deep/ .el-tabs__item {
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.13rem;
}
/deep/ .el-tabs__header {
  margin: 0 0 0.02rem;
}
/deep/ .el-form-item__label {
  padding: 0;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
</style>
